module.exports = "<div align=\"center\" *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">{{message.text}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/_directive/alert.component.html
// module id = ./src/app/sharedcomponents/_directive/alert.component.html
// module chunks = main